"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSpecialistPendingPrescriptions = void 0;
const firestore_1 = require("@react-query-firebase/firestore");
const firestore_2 = require("firebase/firestore");
const keyFactory_1 = require("../../Firestore-Query/keyFactory");
/**
 *
 * @param medicalRecords
 */
function getPendingMedicalRecords(medicalRecords) {
    return medicalRecords.filter((medicalRecord) => !medicalRecord.timestamps.dt_close);
}
/**
 *
 * @param firestore
 * @param uid
 * @param options
 * @param useQueryOptions
 */
function useSpecialistPendingPrescriptions(firestore, uid, options, useQueryOptions) {
    const medicalRecordsRef = (0, firestore_2.collection)(firestore, `user/${uid}`, "medical_records");
    const queryRef = (0, firestore_2.query)(medicalRecordsRef, (0, firestore_2.where)("att_category", "==", "QUICKPRESCRIPTION"));
    return (0, firestore_1.useFirestoreQueryData)(keyFactory_1.FirestoreKeys.Especialista({
        name: "SpecialistPendingPrescriptions",
        path: `user/${uid}/medical_records`,
    }, [uid]), queryRef, options, {
        ...useQueryOptions,
        select: getPendingMedicalRecords,
    });
}
exports.useSpecialistPendingPrescriptions = useSpecialistPendingPrescriptions;
exports.default = useSpecialistPendingPrescriptions;
